<h1 class="text-dark text-xl" mat-dialog-title>Riconsegna veicolo</h1>
<div class="w-full" mat-dialog-content>
  <app-return-rental-movement-form
    [closeDialogEvent$]="closeDialogTrigger$"
    [rentalMovement]="rentalMovement"
    [refreshRentalPracticeEvent$]="refreshRentalPracticeEvent$"
  ></app-return-rental-movement-form>
</div>
